import React, { useEffect, useState } from 'react';
import { MapPin, Navigation, ExternalLink } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { weddingData } from '../mockData';

const Maps = () => {
  const { language } = useLanguage();
  const content = weddingData[language].maps;
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  const locations = content.locations.map((loc) => ({
    ...loc,
    mapUrl: `https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${encodeURIComponent(loc.mapQuery)}&zoom=15`,
    googleMapsLink: `https://www.google.com/maps/search/${encodeURIComponent(loc.mapQuery)}`
  }));

  return (
    <div className="min-h-screen pt-24 pb-20 bg-ivory">
      {/* Header - Pastel Luxe */}
      <section className="bg-gradient-to-br from-lilac-100 via-lilac-200 to-lilac-100 py-32 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 left-20 w-64 h-64 bg-gold-200 rounded-full filter blur-3xl animate-float" />
          <div className="absolute bottom-20 right-20 w-64 h-64 bg-lilac-200 rounded-full filter blur-3xl animate-float" style={{ animationDelay: '2s' }} />
        </div>

        <div className={`container mx-auto px-6 sm:px-8 lg:px-12 text-center relative z-10 transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <MapPin className="mx-auto text-gold-500 mb-8" size={64} />
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-playfair font-bold text-plum-900 mb-6">
            {content.title}
          </h1>
          <p className="text-xl text-plum-800 font-montserrat max-w-3xl mx-auto">
            {content.subtitle}
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-gold-500 to-transparent mx-auto rounded-full mt-8" />
        </div>
      </section>

      {/* Locations */}
      <section className="py-20 bg-ivory">
        <div className="container mx-auto px-6 sm:px-8 lg:px-12">
          <div className="max-w-6xl mx-auto space-y-16">
            {locations.map((location, index) => (
              <div
                key={index}
                className={`card-premium overflow-hidden transition-all duration-700 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${index * 150}ms` }}
              >
                <div className="grid lg:grid-cols-2 gap-8">
                  {/* Location Info */}
                  <div className="p-6">
                    <div className="mb-8">
                      <h2 className="text-3xl sm:text-4xl font-playfair font-bold text-plum-900 mb-4">
                        {location.event}
                      </h2>
                      <h3 className="text-2xl font-playfair font-semibold text-gold-600 mb-3">
                        {location.name}
                      </h3>
                      <div className="flex items-start space-x-3 text-plum-700">
                        <MapPin size={20} className="flex-shrink-0 mt-1 text-gold-500" />
                        <p className="font-montserrat">{location.address}</p>
                      </div>
                    </div>

                    <a
                      href={location.googleMapsLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-primary inline-flex items-center space-x-2"
                    >
                      <Navigation size={18} />
                      <span>{language === 'fr' ? 'Ouvrir dans Google Maps' : 'Open in Google Maps'}</span>
                      <ExternalLink size={16} />
                    </a>
                  </div>

                  {/* Map Embed */}
                  <div className="h-80 lg:h-auto min-h-[320px] rounded-xl overflow-hidden border border-lilac-200">
                    <iframe
                      src={location.mapUrl}
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title={location.name}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Maps;
